import React from "react";
import "./Event_card.css";

function Event_card({cardHeading,status, imgSrc, onClick}) {
  return (
    <>
      <section className="Event_card" onClick={onClick}>
        <div className="img_holder">
            <img src={imgSrc} alt="Event" className="Event_img"/>
        </div>

        <div className="text_holder">
            <h4>{cardHeading}</h4>
            {!status && ( <p>Know More</p>)}
           
        </div>
      </section>
    </>
  );
}

export default Event_card;
